import { Component, Input, OnInit, SimpleChanges, ViewChild, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonHelper } from '../../../../shared/helpers/CommonHelper';
import { LocalStorage } from '../../../../shared/wrappers/LocalStorage';
import { GUARDS } from '../../../../shared/auth/Roles';
import { BillingParcelService } from '../../../../services/billing-letter/billing-parcel.service';
import { AccountingPeriodBlock } from "../../../../models/AccountingPeriodBlock.model";
import { AccountingPeriodBlockService } from "../../../../services/accountingBlock.service";
import { CompetenceProvider } from "../../../../shared/providers/enums/billing-letter/competence-provider";
import { StatusProvider } from "../../../../shared/providers/enums/billing-letter/status-provider";
import { Company } from '../../../../models/billing-letter/Company.model';
import * as _ from 'lodash';
import { CnaeService } from '../../../../services/cnae.service';
import { SapItemType } from '../../../../shared/enums/SapItemType';
import { Parcel } from '../../../../models/billing-letter/Parcel.model';
import { ToastsManager } from 'ng2-toastr';
import { BillingLetterService } from '../../../../services/billing-letter/billing-letter.service';
import { ErrorHandlerProvider } from '../../../../shared/providers/errorHandler.provider';
import * as moment from 'moment';
import { AccountingType } from '../../../../shared/enums/AccountingBlockType';

@Component({
    selector: 'modal-parcels',
    templateUrl: './modal-parcels.component.html',
    styleUrls: ['../../billing-letter-edit/billing-letter-edit.component.scss']
})
export class ModalParcelsComponent implements OnInit {
    @ViewChild("buttonCloseModalParcel") buttonCloseModalParcel: ElementRef;
    @ViewChild("accountingLoss") accountingLoss: ElementRef;
    @Input() idParcel: string;
    @Input() indexParcel: number;
    @Input() objParcel: any;
    @Input() billingLetterUpdate: any;
    @Input() isCreate: boolean;
    @Input() isRecurrence: boolean;
    @Input() companies: Company[] = [];
    @Output() closeModal: EventEmitter<boolean> = new EventEmitter();

    i: number;
    numberParcel: number;
    loadingModal: boolean = false;

    parcel: any;
    user;
    GUARDS = GUARDS;
    allowedRoles = [GUARDS.MANAGER, GUARDS.GOVERNANCE, GUARDS.FINANCES, GUARDS.BILLSRECEIVE];
    canSave: Boolean = true;
    accountingBlock = new AccountingPeriodBlock();
    refundsDropdown = {
        list: [],
        options: null,
        selected: []
    };

    competences = this.competenceProvider.competences;
    statuses = this.statusesProvider.statuses;
    cnaes;
    competenceYear = this.commonHelper.listLastYears();
    datePickerOptions = this.commonHelper.getDatePickerOptions();

    parcelIndexAddRefund: number = -1;
    refundsToUpdate = [];

    oldParcel: any;

    billingLetter: any

    months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

    apportionment: any;
    indexParcelModalRATEIO: number;
    isModalOpen: boolean = false;
    whichModalIsOpen: string = '';
    recurrence = 1;
    eaParcels = false;
    partialInvoicesIntegrated: boolean = false;
    statusOld: string

    constructor(
        private commonHelper: CommonHelper,
        private localStorage:LocalStorage,
        private billingParcelService: BillingParcelService,
        private accountingPeriodBlockService: AccountingPeriodBlockService,
        private competenceProvider: CompetenceProvider,
        private statusesProvider: StatusProvider,
        private cnaeService: CnaeService,
        private toastr: ToastsManager,
        private billingLetterService: BillingLetterService,
        private errorHandler: ErrorHandlerProvider,
        private route: ActivatedRoute,
        private router: Router
    ) {}

    async ngOnInit() {
        this.accountingBlock = (await this.accountingPeriodBlockService.getAllBlockedPeriods())
        .find((ac: AccountingPeriodBlock) => ac.type === AccountingType.BillingLetter);

        this.checkPermissions();
        this.cnaes = await this.cnaeService.getAllItems([SapItemType.CnaeBilling]);

        if(this.accountingBlock && this.accountingBlock.competenceYear &&
           this.accountingBlock.competence){
            this.datePickerOptions.minDate = new Date(this.accountingBlock.competenceYear,this.accountingBlock.competence,1);
        }
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event.keyCode === 27 && this.isModalOpen && this.whichModalIsOpen == 'modalParcels') {
            this.toogleModal(this.whichModalIsOpen)

        } else if (event.keyCode === 27 && this.isModalOpen && this.whichModalIsOpen == 'rateioModal'){
            this.toogleModal(this.whichModalIsOpen)
            this.whichModalIsOpen = 'modalParcels';
            this.isModalOpen = true;
        }
    }

    modalLayer(modalType: string) {
        return modalType
    }

    async ngOnChanges(changes: SimpleChanges) {
        if(changes.idParcel && changes.idParcel.currentValue) {
            let id = changes.idParcel.currentValue.split('-');
            if(!this.isCreate) {
                this.parcel = await this.billingParcelService.getByID(id[0]);
                this.oldParcel = _.cloneDeep(this.parcel);
                this.registerIndustryInParcel();
            } else {
                this.parcel = await this.billingParcelService.getByID(id[0]);

                const nextMonth = Number(this.parcel.competence) + 1;
                const nextYear = Number(this.parcel.competenceYear);
                const monthYear = this.nextMonthYear(nextMonth, nextYear);

                this.parcel.competence = monthYear.month;
                this.parcel.competenceYear = monthYear.year;
                this.parcel.issueDate = moment(this.parcel.issueDate).add(1, 'months').toDate();
                this.parcel.dueDate = moment(this.parcel.dueDate).add(1, 'months').toDate();
                this.parcel.created = moment()
                this.parcel.status = 1;
                this.parcel.issued = false;
                this.parcel.parcelCanceled = false;
                this.parcel.sapDocEntry = '';
                this.parcel.sapDocNum = '';
                this.parcel.integratedSap = false;
                this.parcel.parcelJoin = '';
                this.parcel.observation = '';
                this.parcel.nf = '';
                this.parcel.refund = [];
                this.parcel.hasPartialInvoice = false;
                this.parcel.partialInvoices = [];
                this.parcel.accountingLoss = 0;
                this.parcel.accountingLossJustification = '';
                this.parcel.isAnticipation = false;
                this.registerIndustryInParcel();
                if(this.isInactiveCustomer()) {
                    this.parcel.company = null;
                }
            }
            this.checkCompetence();
        } else {
            if(changes.objParcel && changes.objParcel.currentValue) {
                this.parcel = this.objParcel;
                this.checkCompetence();
            }
        }

        if(changes.indexParcel && (changes.indexParcel.currentValue || changes.indexParcel.currentValue == 0)) {
            this.i = changes.indexParcel.currentValue;
            this.numberParcel = changes.indexParcel.currentValue;
        } else {
            if(changes.idParcel && changes.idParcel.currentValue) {
                let id = changes.idParcel.currentValue.split('-');
                let iParcel = this.billingLetterUpdate.parcels.findIndex(i => i._id == id[0]);
                this.i = iParcel;
                this.numberParcel = iParcel;
            }
        }

        if(changes.billingLetterUpdate && changes.billingLetterUpdate.currentValue) {
            this.billingLetter = changes.billingLetterUpdate.currentValue
        }
        if(this.parcel) this.statusOld = this.parcel.status;
    }

    nextMonthYear(month: number, year: number) {
        const currentMonth = this.months.indexOf(month)
        if (currentMonth === -1)
            return {
                month: this.months[0],
                year: year + 1
            }

        return {
            month: this.months[currentMonth],
            year: year
        }
    }

    formatDate(date: Date) {
        return this.eaParcels ? moment(date) : moment(date).add(1, 'month')
    }

    checkPermissions() {
        this.user = this.localStorage.retrieve('user');
        if(!this.allowedRoles.includes(this.user.permission)) {
            this.canSave = false;
        }
    }

    getValuePartial(parcel){
        let sumProject = parcel.project.reduce((acc, { value }) => acc + value, 0);
        let sumProduct = parcel.product.reduce((acc, { value }) => acc + value, 0);
        let sumRefund = parcel.refund.reduce((acc, { value }) => acc + value, 0);
        return parcel.value - sumProduct - sumProject - sumRefund;
    }

    compare(val1, val2) {
        if (val1 && val2) {
            return val1._id === val2._id;
        } else
            return false;
    }

    checkParcel(parcel): string {
        if(!parcel.canEdit || parcel.status >= 4 || parcel.issued) {
            return "disable";
        }

        return "activate";
    }

    checkCompetence() {
        let statusesAllowed = [1, 2, 3, 9];
        if(this.parcel.issued || this.parcel.nf) {
            this.parcel.canEdit = false;
        } else if(statusesAllowed.includes(Number(this.parcel.status))) {
            this.parcel.canEdit = true;
        } else if(this.accountingBlock) {
            if(this.parcel.competenceYear && this.parcel.competence){
                let totalBlocking = this.accountingBlock.competenceYear + (this.accountingBlock.competence / 100);
                let totalParcel = this.parcel.competenceYear + (this.parcel.competence / 100);
                this.parcel.canEdit = totalParcel <= totalBlocking ? false : true;
            }
        }
    }

    statusDisabled(status:number){
        if(status < 4 && (this.user.permission == GUARDS.FINANCES || this.user.permission == GUARDS.BILLSRECEIVE)){
            return true;
        }else if(status > 3 && this.user.permission != GUARDS.FINANCES && this.user.permission != GUARDS.BILLSRECEIVE)
            return true;
        return false;
    }

    setParcelIndexToAddRefund(i) {
        this.parcelIndexAddRefund = parseInt(i);
    }


    removeRefund(refundId) {
        let refundListAux = this.parcel.refund;
        let refundAux = refundListAux.find(refund => refund._id === refundId);
        refundListAux = refundListAux.filter(refund => refund._id !== refundId);

        this.parcel.refund = refundListAux;
        this.refundsDropdown.list.push({
            id: refundAux._id,
            itemName: refundAux.name,
            value: refundAux.value,
        });
        this.refundsToUpdate = this.refundsToUpdate.filter(refund => refund._id !== refundAux._id);
    }

    calculateValueLiquid() {
        const parcel = this.parcel;
        let valueLiquid = parcel.value;
        if(!isNaN(parcel.iss)) valueLiquid -= parcel.iss;
        if(!isNaN(parcel.pis)) valueLiquid -= parcel.pis;
        if(!isNaN(parcel.irrf)) valueLiquid -= parcel.irrf;
        if(!isNaN(parcel.cofins)) valueLiquid -= parcel.cofins;
        if(!isNaN(parcel.discountGranted)) valueLiquid -= parcel.discountGranted;
        this.parcel.valueLiquid = valueLiquid;
    };

    disabledParcel(parcel:Parcel){
        if(parcel.status == 6)
            return true;
        else if(parcel.status > 3 && this.user.permission != GUARDS.FINANCES && this.user.permission != GUARDS.BILLSRECEIVE)
            return true;
        return false;
    }

    async save() {
        this.loadingModal = true;
        if(this.parcel) {
            if(!this.objParcel) {
                //Modal Parcela em Edição de Carta de Faturamento (criando ou editando parcela)
                let changedParcel = !this.isCreate ? this.verifyChangedParcel() : true;
                if(changedParcel || this.isRecurrence) {
                    let parcelValid = this.validParcel();
                    if(parcelValid) {
                        this.parcel['U_NEO_Agrupador'] = this.billingLetter.name;
                        if(!this.isCreate) {
                            let res = await this.billingParcelService.updateOne(this.parcel);
                            if(res._id) {
                                this.toastr.success("Parcela atualizada com sucesso");
                                let iParcel = this.billingLetterUpdate.parcels.findIndex(i => i._id == res._id);

                                if(res.status < 5) res.canEdit = true;

                                this.billingLetter.parcels[iParcel] = res;
                                this.buttonCloseModalParcel.nativeElement.click();
                                this.closeModal.emit(false);
                            } else {
                                this.errorHandler.interceptError(res, 'Parcela');
                            }
                        } else {
                            delete this.parcel._id;

                            if(this.isRecurrence) {
                                let qtdSucessos = 0;
                                let qtdError = 0;
                                this.parcel.billingLetterId = this.route.snapshot.params['id'];
                                for (let i = 1; i <= this.recurrence; i++) {
                                    const parcelRecurrence = _.cloneDeep(this.parcel);
                                    let res = await this.billingParcelService.create(parcelRecurrence);
                                    if(res._id) {
                                        qtdSucessos++;

                                        let newParcel = new Parcel(res);
                                        newParcel.canEdit = true;
                                        this.billingLetter.parcels.push(newParcel);
                                    } else {
                                        qtdError++;
                                    }

                                    const nextMonth = Number(this.parcel.competence) + 1;
                                    const nextYear = Number(this.parcel.competenceYear);
                                    const monthYear = this.nextMonthYear(nextMonth, nextYear);

                                    this.parcel.competence = monthYear.month;
                                    this.parcel.competenceYear = monthYear.year;
                                    this.parcel.issueDate = this.formatDate(this.parcel.issueDate);
                                    this.parcel.dueDate = this.formatDate(this.parcel.dueDate);
                                    this.parcel.paymentDate = this.formatDate(this.parcel.paymentDate);
                                }

                                if(qtdSucessos)
                                    this.toastr.success(`${qtdSucessos} parcela(s) da recorrência criada(s) com sucesso`, 'Operação finalizada', {
                                        toastLife: 5000,
                                        showCloseButton: true
                                    });
                                if(qtdError)
                                    this.toastr.warning(`Erro ao criar ${qtdError} parcela(s) da recorrência`, 'Operação finalizada', {
                                        toastLife: 5000,
                                        showCloseButton: true
                                    });

                                this.buttonCloseModalParcel.nativeElement.click();
                                this.closeModal.emit(true);

                            } else {
                                let res = await this.billingParcelService.create(this.parcel);
                                if(res._id) {
                                    this.toastr.success("Parcela criada com sucesso");

                                    let newParcel = new Parcel(res);
                                    newParcel.canEdit = true;
                                    this.billingLetter.parcels.push(newParcel);

                                    this.buttonCloseModalParcel.nativeElement.click();
                                    this.closeModal.emit(true);
                                } else {
                                    this.errorHandler.interceptError(res, 'Parcela');
                                }
                            }
                        }
                    }
                } else {
                    this.toastr.info("Não existem alterações a serem salvas");
                }
            } else {
                //Modal Parcela em Criação de Carta de Faturamento (adicionando ou editando parcela)
                let parcelValid = this.validParcel();
                if(parcelValid) {
                    if(this.numberParcel || this.numberParcel == 0) {
                        if(this.isRecurrence) {
                            let indexParcelRecurrence = this.numberParcel;
                            for (let i = 1; i <= this.recurrence; i++) {
                                const parcelRecurrence = _.cloneDeep(this.parcel);
                                this.billingLetter.parcels[indexParcelRecurrence] = parcelRecurrence;

                                const nextMonth = Number(this.parcel.competence) + 1;
                                const nextYear = Number(this.parcel.competenceYear);
                                const monthYear = this.nextMonthYear(nextMonth, nextYear);

                                this.parcel.competence = monthYear.month;
                                this.parcel.competenceYear = monthYear.year;
                                this.parcel.issueDate = this.formatDate(this.parcel.issueDate);
                                this.parcel.dueDate = this.formatDate(this.parcel.dueDate);
                                this.parcel.paymentDate = this.formatDate(this.parcel.paymentDate);

                                indexParcelRecurrence++;
                            }
                        } else {
                            this.billingLetter.parcels[this.numberParcel] = this.parcel;
                        }

                        this.toastr.success("Parcela(s) adicionada(s) com sucesso");
                        this.buttonCloseModalParcel.nativeElement.click();
                        this.closeModal.emit(true);
                    }
                }
            }
        }
        this.loadingModal = false;
    }

    validParcel() {
        let validParcels = true;
        let totalBlocking = null;
        let accountingBlockCreation = null;

        if(this.accountingBlock !== null) {
            totalBlocking = this.accountingBlock.competenceYear + (this.accountingBlock.competence / 100);
            accountingBlockCreation = Number(moment(this.accountingBlock.created).format("YYYY.MM"));
        }

        const existsProject = this.parcel.project && this.parcel.project.length > 0
        const existsProduct = this.parcel.product && this.parcel.product.length > 0
        const existsRefud = this.parcel.refund && this.parcel.refund.length > 0
        const validStatus = this.parcel.status > 1 && (this.parcel.status != 6 && this.parcel.status != 8)
        const unselectedCustomer = (!this.parcel.company || !this.parcel.industry);
        const invalidCompetence = this.parcel.competence == 0 || this.parcel.competenceYear == 0
        const hasApportionment = this.parcel.excellenceCenters.length && this.parcel.industry
        const accountingLossInvalid = this.parcel.status == 8 && (!this.parcel.accountingLoss || !this.parcel.accountingLossJustification || this.parcel.accountingLoss != this.parcel.value)

        if (unselectedCustomer) {
            this.toastr.warning(`Selecione um cliente e setor para salvar/editar a parcela`);
            validParcels = false;
        } else if (!hasApportionment) {
            this.toastr.warning(`É necessário definir o Rateio entre Eixos para criação da parcela`);
            validParcels = false;
        } else if(invalidCompetence){
            this.toastr.warning(`Selecione o mês e o ano da competencia para salvar/editar a parcela`);
            validParcels = false
        } else if(accountingLossInvalid){
            this.toastr.warning('Os campos valor da perda contábil e justificativa são obrigatórios. O valor da perda deve ser igual ao valor da parcela', 'Perda competência inválida');
            validParcels = false
        };

        if ((existsProject || existsProduct || existsRefud) && validStatus) {
            let totalParcel = null;
            if(this.parcel.competenceYear && this.parcel.competence && this.parcel.competenceYear != 0 && this.parcel.competence != 0) {
                totalParcel = parseInt(this.parcel.competenceYear.toString()) + (parseInt(this.parcel.competence.toString()) / 100);
            }

            let sumProject = this.parcel.project.reduce((acc, { value }) => acc + value, 0);
            let sumProduct = this.parcel.product.reduce((acc, { value }) => acc + value, 0);
            let sumRefund = this.parcel.refund.reduce((acc, { value }) => acc + value, 0);
            const sumParcels = sumProduct + sumProject + sumRefund;
            if (this.parcel.value == 0) {
                this.toastr.warning(`O valor total da parcela ${this.parcel.competence}/${this.parcel.competenceYear} não pode ser 0`, 'Valor inválido')
                validParcels = false;
            } else if (parseFloat(sumParcels.toFixed(2)) != this.parcel.value) {
                this.toastr.warning(`Rateio inválido na parcela ${this.parcel.competence}/${this.parcel.competenceYear}`, 'Rateio inválido', {
                    toastLife: 8000,
                    showCloseButton: true
                });
                validParcels = false;
            } else if (!this.parcel.cnae || !this.parcel.noteType || !this.parcel.paymentMethod || !this.parcel.paymentTerm) {
                this.toastr.warning(`CNAE, tipo da nota, forma ou condição de pagamento não está inserido na parcela ${this.parcel.competence}/${this.parcel.competenceYear}`, 'Dados obrigatórios')
                validParcels = false;
            } else if (this.parcel.body && (this.parcel.body.length > 1950 || this.parcel.body.split('\n').length > 24)) {
                this.toastr.warning(`O corpo na parcela ${this.parcel.competence}/${this.parcel.competenceYear} passou a quantidade permitida de caracteres ou linhas`)
                validParcels = false;
            } else if(this.parcel.canEdit && totalParcel && totalBlocking && totalParcel <= totalBlocking) {
                let isInvalid = true;
                const dateCreated = Number(moment(this.parcel.created).format("YYYY.MM"));
                if(Number(this.parcel.status) === 3) {
                    isInvalid = false;
                } else if(this.parcel.sapDocEntry && Number(this.statusOld) === 2 && dateCreated <= accountingBlockCreation) {
                    isInvalid = false;
                }

                if(isInvalid) {
                    this.toastr.warning(`A competência ${this.parcel.competence}/${this.parcel.competenceYear} da parcela #${this.numberParcel+1}, está dentro do intervalo de bloqueio.`, 'Bloqueio de auditoria', {
                        toastLife:8000,
                        showCloseButton: true
                    });
                    validParcels = false;
                }
            }
        }

        return validParcels;
    }

    verifyChangedParcel() {
        let changedParcel = this.parcel.body != this.oldParcel.body ||
        this.parcel.cnae != this.oldParcel.cnae ||
        this.parcel.cofins != this.oldParcel.cofins ||
        this.parcel.company._id != this.oldParcel.company._id ||
        this.parcel.competence != this.oldParcel.competence ||
        this.parcel.competenceYear != this.oldParcel.competenceYear ||
        this.parcel.discountGranted != this.oldParcel.discountGranted ||
        this.parcel.dueDate != this.oldParcel.dueDate ||
        this.parcel.irrf != this.oldParcel.irrf ||
        this.parcel.iss != this.oldParcel.iss ||
        this.parcel.issueDate != this.oldParcel.issueDate ||
        this.parcel.issued != this.oldParcel.issued ||
        this.parcel.noteType != this.oldParcel.noteType ||
        this.parcel.parcelCanceled != this.oldParcel.parcelCanceled ||
        this.parcel.paymentDate != this.oldParcel.paymentDate ||
        this.parcel.paymentMethod != this.oldParcel.paymentMethod ||
        this.parcel.paymentTerm != this.oldParcel.paymentTerm ||
        this.parcel.status != this.oldParcel.status ||
        this.parcel.value != this.oldParcel.value ||
        this.parcel.isAnticipation != this.oldParcel.isAnticipation ||
        this.parcel.valueLiquid != this.oldParcel.valueLiquid ||
        this.parcel.observation != this.oldParcel.observation ||
        this.parcel.body != this.oldParcel.body ||
        this.parcel.nf != this.oldParcel.nf ||

        JSON.stringify(this.parcel.industry) != JSON.stringify(this.oldParcel.industry) ||
        JSON.stringify(this.parcel.excellenceCenters) != JSON.stringify(this.oldParcel.excellenceCenters) ||
        JSON.stringify(this.parcel.supportCenters) != JSON.stringify(this.oldParcel.supportCenters);

        for(let i in this.parcel.product)
            if(this.parcel.product[i].value != this.oldParcel.product[i].value)
                changedParcel = true;
        for(let i in this.parcel.project)
            if(this.parcel.project[i].value != this.oldParcel.project[i].value)
                changedParcel = true;
        for(let i in this.parcel.refund)
            if(this.parcel.refund[i].value != this.oldParcel.refund[i].value)
                changedParcel = true;

        return changedParcel;
    }

    async delete() {
        if(!this.objParcel) {
            let id = this.idParcel.split('-');
            let iParcel = this.billingLetterUpdate.parcels.findIndex(i => i._id == id[0]);
            this.billingLetter.parcels.splice(iParcel, 1);

            let res;
            let successMessage;
            if(this.parcel.sapDocEntry) {
                await this.billingParcelService.delete(this.parcel);
                res = await this.billingLetterService.update(this.billingLetter, this.billingLetter._id);
                successMessage = 'Pedido de venda cancelado no SAP'
            } else {
                Object.assign(this.billingLetter, {parcelId: this.parcel._id, isDeletion: true})
                res = await this.billingLetterService.update(this.billingLetter, this.billingLetter._id);
                successMessage = 'Parcela deletada com sucesso'
                const parcelIndex = this.billingLetterUpdate.parcels.findIndex((parcel: Parcel) => parcel._id == this.parcel._id)
                if (parcelIndex >= 0) {
                    this.billingLetterUpdate.parcels.splice(parcelIndex, 1);
                    const hasUrlFragment = this.route.snapshot.fragment;

                    //Verifica se o usuário chegou até a rota por fragment da listagem, comparando id's para não ocorrer erros após a deleção
                    if (hasUrlFragment && hasUrlFragment.split('-')[1] == this.parcel._id) {
                        const urlId = this.route.snapshot.params['id']
                        this.router.navigate([`/billing-letter/edit/${urlId}`])
                    }
                }

            }

            if(res.data._id) {
                this.toastr.success(successMessage);
            } else {
                this.errorHandler.interceptError(res, 'Parcela');
            }
        } else {
            if(this.indexParcel >= 0) {
                this.billingLetter.parcels.splice(this.indexParcel, 1);
                this.toastr.success("Parcela deletada com sucesso");
            }
        }
    }

    registerIndustryInParcel() {
        if(this.parcel.industry && this.parcel.status != 1) return;
        if(this.parcel.company && this.parcel.company._id) {
            const parcelCompany = this.companies.find(({ _id }) => _id === this.parcel.company._id);
            if(parcelCompany)
                this.parcel.industry = { ...parcelCompany.industry, percentage: 100 };
        }
    }

    isInactiveCustomer() {
        const selectedCompany = this.companies.find(c => c._id === this.parcel.company._id);
        if(selectedCompany && !selectedCompany.active)
            return true;
        return false;
    }

    async changeClient() {
        if(this.isInactiveCustomer()) {
            this.parcel.company = null;
            return this.toastr.warning('Atenção: O cliente selecionado está inativo');
        }

        if (this.parcel.company && this.parcel.company.industry) {
            this.parcel.industry = this.parcel.company.industry
        }
    }

    sendModalApportionment() {
        this.toogleModal('rateioModal')
        let industry = this.parcel.industry ? [this.parcel.industry] : this.parcel.company.industry ? [this.parcel.company.industry] : [];
        this.apportionment = {
            industries: industry,
            excellenceCenters: this.parcel.excellenceCenters,
            supportCenters: this.parcel.supportCenters
        }
    }

    getModalApportionment(apportionment) {
        let excellenceCenters = apportionment.excellenceCenters.filter(excellenceCenter => excellenceCenter.percentage > 0);
        let supportCenters = apportionment.supportCenters.filter(supportCenter => supportCenter.percentage > 0);

        this.parcel.excellenceCenters = excellenceCenters.map(excellenceCenter => {
            return {
                ...excellenceCenter,
                value: this.contPercentage(this.parcel.value, excellenceCenter.percentage)
            };
        });

        this.parcel.supportCenters = supportCenters.map(supportCenter => {
            return {
                ...supportCenter,
                value: this.contPercentage(this.parcel.value, supportCenter.percentage)
            };
        });
    }

    contPercentage(value, percentage) {
        return (value * percentage) / 100;
    }

    changeCloseModal() {
        this.closeModal.emit(false);
    }

    toogleModal(modalId: string, isRatioModalClosed = false): void {
        const modal = document.getElementById(modalId)
        this.whichModalIsOpen = modalId;
        if (modal.style.display === "none") {
            modal.style.display = "block"
            this.isModalOpen = false;
        } else {
            modal.style.display = "none"
            this.isModalOpen = true;
        }

        if (modalId == 'rateioModal' && isRatioModalClosed) {
            this.whichModalIsOpen = 'modalParcels';
            this.isModalOpen = true;
        }
    }

    changeStatus() {
        if(this.parcel.status == 8) {
            this.accountingLoss.nativeElement.setAttribute('style', "border: 1px solid #F00 !important;");
            this.accountingLoss.nativeElement.focus();
            setTimeout(() =>  {
                this.accountingLoss.nativeElement.setAttribute('style', "border: none !important;");
                this.accountingLoss.nativeElement.setAttribute('style', "border-bottom: 1px solid #ccc !important");
            }, 2000)
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/views/billing-letter/components/modal-parcels/modal-parcels.component.ts